import { render, staticRenderFns } from "./DropshipFields.vue?vue&type=template&id=5578d99e&"
import script from "./DropshipFields.vue?vue&type=script&lang=js&"
export * from "./DropshipFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports